import React from 'react';
import FormFieldV2 from './FormFieldV2';
import V2_CONTACT_CATEGORIES from '../../data/v2ContactCategories';

const COPY = {
  en: {
    label: 'Reason for contact',
    hint: 'Choose the option that best describes your inquiry.',
    placeholder: '— Select a reason —',
    existing_client_note: 'For active project questions, include the project or business name so we can route your message correctly.',
  },
  es: {
    label: 'Motivo del contacto',
    hint: 'Elige la opción que mejor describa tu consulta.',
    placeholder: '— Selecciona un motivo —',
    existing_client_note: 'Para preguntas sobre un proyecto activo, incluye el nombre del proyecto o negocio para que podamos dirigir tu mensaje correctamente.',
  },
};

const ContactCategorySelectV2 = ({ lang = 'en', value, onChange, error }) => {
  const t = COPY[lang] || COPY.en;
  return (
    <>
      <FormFieldV2
        id="reason"
        as="select"
        label={t.label}
        hint={t.hint}
        required
        error={error}
        value={value || ''}
        onChange={onChange}
        data-testid="iv2-contact-category-select"
      >
        <option value="">{t.placeholder}</option>
        {V2_CONTACT_CATEGORIES.map((cat) => (
          <option key={cat.value} value={cat.value}>
            {cat.label[lang] || cat.label.en}
          </option>
        ))}
      </FormFieldV2>
      {value === 'existing_client' && (
        <p
          className="iv2-contact-inline-note"
          role="note"
          data-testid="iv2-contact-existing-client-note"
        >
          {t.existing_client_note}
        </p>
      )}
    </>
  );
};

export default ContactCategorySelectV2;
